import React from 'react';
import { Typography } from 'antd';
import { TextProps } from 'antd/lib/typography/Text';

import './style.less';

const EllipsisHoverToggle: React.FC<TextProps> = ({ children, ...props }) => {
  return (
    <Typography.Text className="ellipsis-expand-on-hover" {...props}>
      {children}
    </Typography.Text>
  );
};

export default EllipsisHoverToggle;
